// src/pages/Account/SafeForm.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from '../../axios';
import chartOfAccountsApi from '../../api/chartOfAccountsApi'; // Added

import { Input }    from '../../components/ui/input';
import { Checkbox } from '../../components/ui/checkbox';
import { Button }   from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';
import SearchableSelect from '../../components/ui/SearchableSelect'; // Added

export default function SafeForm() {
  const navigate  = useNavigate();
  const { id }    = useParams();
  const editingId = id ? parseInt(id, 10) : null;

  // قراءة companyId و branchId من التوكن/التخزين المحلي
  const companyId = parseInt(localStorage.getItem('companyId'), 10);
  const branchId  = parseInt(localStorage.getItem('branchId'), 10);

  const [accounts, setAccounts] = useState([]); // Added

  const [form, setForm] = useState({
    Name:        '',
    Status:      true,
    IsDefault:   false,
    Notes:       '',
    is_deleted:  false,
    AccountId:   null, // Added
    CompanyId:   companyId,
    BranchId:    branchId
  });

  useEffect(() => {
    // Fetch Accounts
    chartOfAccountsApi.getPostable().then(res => setAccounts(res.data || [])).catch(console.error);

    if (editingId) {
      axios.get(`/Safe/${editingId}`)
        .then(r => {
          const d = r.data;
          setForm({
            Name:       d.Name       || '',
            Status:     d.Status     ?? true,
            IsDefault:  d.IsDefault  ?? false,
            Notes:      d.Notes      || '',
            is_deleted: d.is_deleted ?? false,
            AccountId:  d.AccountId  || null, // Added
            CompanyId:  companyId,
            BranchId:   branchId
          });
        })
        .catch(console.error);
    }
  }, [editingId, companyId, branchId]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(f => ({ ...f, [name]: value }));
  };
  const handleCheckbox = e => {
    const { name, checked } = e.target;
    setForm(f => ({ ...f, [name]: checked }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`/Safe/${editingId}`, form);
        alert('✅ تم تحديث الصندوق');
      } else {
        await axios.post(`/Safe`, form);
        alert('✅ تم إنشاء صندوق جديد');
      }
      navigate('/safes');
    } catch (err) {
      console.error(err);
      alert('❌ حدث خطأ أثناء الحفظ');
    }
  };

  return (
    <Card className="max-w-md mx-auto mt-10" dir="rtl">
      <CardContent>
        <h2 className="text-xl font-bold mb-6">
          {editingId ? 'تعديل صندوق' : 'صندوق جديد'}
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">

          {/* الاسم */}
          <div>
            <label className="block mb-1">اسم الصندوق</label>
            <Input
              name="Name"
              value={form.Name}
              onChange={handleChange}
              required
            />
          </div>

          {/* الحساب المرتبط */}
          <div>
            <label className="block mb-1">الحساب المرتبط (دليل الحسابات)</label>
            <SearchableSelect
                options={accounts}
                value={form.AccountId}
                onChange={(val) => setForm(f => ({ ...f, AccountId: val }))}
                getOptionLabel={(option) => `${option.code} - ${option.nameAr}`}
                getOptionValue={(option) => option.id}
                placeholder="اختر الحساب..."
            />
          </div>

          {/* حالة الصندوق */}
          <div className="flex items-center gap-2">
            <Checkbox
              id="Status"
              name="Status"
              checked={form.Status}
              onChange={handleCheckbox}
            />
            <label htmlFor="Status">نشط</label>
          </div>

          {/* افتراضي */}
          <div className="flex items-center gap-2">
            <Checkbox
              id="IsDefault"
              name="IsDefault"
              checked={form.IsDefault}
              onChange={handleCheckbox}
            />
            <label htmlFor="IsDefault">افتراضي</label>
          </div>

          {/* ملاحظات */}
          <div>
            <label className="block mb-1">ملاحظات</label>
            <Input
              name="Notes"
              value={form.Notes}
              onChange={handleChange}
            />
          </div>

          {/* محذوف */}
          <div className="flex items-center gap-2">
            <Checkbox
              id="is_deleted"
              name="is_deleted"
              checked={form.is_deleted}
              onChange={handleCheckbox}
            />
            <label htmlFor="is_deleted">محذوف</label>
          </div>

          {/* الأزرار */}
          <div className="flex justify-end gap-2 mt-6">
            <Button type="submit">💾 حفظ</Button>
            <Button variant="outline" onClick={() => navigate('/safes')}>
              ↩️ رجوع
            </Button>
          </div>

        </form>
      </CardContent>
    </Card>
  );
}
